import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpOnlineFiInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const modifiedHeaders = req.headers.set('scope', 'PFI');
        const clonedReq = req.clone({ headers: modifiedHeaders });

        return next.handle(clonedReq);
    }
}
